import HeroBg from "public/labAsAService/hero-section-background.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Start your cloud lab experience today",
    link: "contact-us",
  },
  title: "OneMind’s Cloud Lab as a Service for IT Workflows",
  desc: "On-demand virtual labs designed for agile testing and secure development workflows. Spin up environments instantly and reduce infrastructure overhead.",
  image: HeroBg,
  cmlPowered: true,
};
